import script from "./MainApp.vue?vue&type=script&setup=true&lang=js"
export * from "./MainApp.vue?vue&type=script&setup=true&lang=js"

import "./MainApp.vue?vue&type=style&index=0&id=bf677c96&lang=scss"

const __exports__ = script;

export default __exports__